import Plausible from 'plausible-tracker'

const { trackPageview, trackEvent } = Plausible({
  // Track localhost by default
  trackLocalhost: false,
  domain: process.env.PLAUSIBLE_DOMAIN || 'cockpit.globe-groupe.com',
})

export { trackPageview, trackEvent }
